import PropTypes from 'prop-types';
import React from 'react';

import LogRocket from '@helpers/logRocket';

import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';

const Uppy = require('@uppy/core');
const { Dashboard } = require('@uppy/react');
const Transloadit = require('@uppy/transloadit');

const { TransloaditTemplateMap } = require('@helpers/uppy');

class UppyUploader extends React.Component {
  constructor(props) {
    super(props);
    const { handleUpload, uniqIdentifier, restrictions, template, locale } = props;

    this.templateName = template.replace(/-/g, '_');

    this.restrictionOptions = () => {
      const defaultRestrictions = {
        maxNumberOfFiles: 3000
      };
      return Object.assign(defaultRestrictions, restrictions);
    };

    this.uppy = Uppy({
      allowMultipleUploads: true,
      id: `${uniqIdentifier}-uppy`,
      restrictions: this.restrictionOptions(),
      locale,
    }).use(Transloadit, {
      params: {
        auth: { key: "8f0a1220e6ae11e8a5c1c16a4395f2d8" }, // Transloadit API key (not secret)
        template_id: TransloaditTemplateMap()[this.templateName]
                      || TransloaditTemplateMap().file_ingest
      },
      waitForEncoding: true // ensures request has processed with metadata
    }).on('upload-error', (file, body) => {
      this.handleError(file, body);
    }).on('transloadit:complete', (assembly) => {
      const files = assembly.results[":original"]
        || assembly.results[this.templateName];
      handleUpload(files);
    });
  }

  handleError(file, error) {
    window?.DD_RUM?.onReady(function() {
        window.DD_RUM.addError('Error Uploading File to Transloadit', {
        tags: {},
        extra: { file, error }
      });
    });
    LogRocket.captureMessage('Error Uploading File to Transloadit', {
      tags: {},
      extra: { file, error }
    });
  }

  renderDragAndDrop = () => (
    <Dashboard
      inline
      proudlyDisplayPoweredByUppy={false}
      showProgressDetails
      uppy={this.uppy}
      width={10}
    />
  )

  renderButton = () => {
    const { trigger } = this.props;
    return (
      <Dashboard
        browserBackButtonClose
        closeAfterFinish
        closeModalOnClickOutside
        inline={false}
        proudlyDisplayPoweredByUppy={false}
        showProgressDetails
        trigger={trigger}
        uppy={this.uppy}
        width={10}
      />
    );
  }

  render() {
    return this.props.button ? this.renderButton() : this.renderDragAndDrop();
  }
}

UppyUploader.propTypes = {
  handleUpload: PropTypes.func.isRequired,
  uniqIdentifier: PropTypes.string.isRequired,
  restrictions: PropTypes.shape({ maxNumberOfFiles: PropTypes.number }),
  locale: PropTypes.shape({ strings: PropTypes.shape({ dropHereOr: PropTypes.string, browse: PropTypes.string }) }),
  button: PropTypes.bool,
  template: PropTypes.string,
  trigger(props) {
    if (props.button && !props.trigger) {
      return new Error("Provide a target (element #id) when using a button");
    }
    if (props.trigger && !props.trigger.includes("#")) {
      return new Error(`Target prop must begin with a '#',
        ${props.uniqIdentifier} trigger element will not respond to click event`);
    }
    return null;
  }
};

UppyUploader.defaultProps = {
  template: "file_ingest",
  restrictions: {},
  // https://github.com/transloadit/uppy/blob/master/packages/%40uppy/locales/src/en_US.js
  locale: { strings: { dropPaste: "Drag file(s) here or %{browse}", dropHereOr: "Drag file(s) here or %{browse}", browse: "click to browse" } },
  button: false,
  trigger: undefined
};

export default UppyUploader;
